var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', _vm._g(_vm._b({
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.pause,
      expression: "pause"
    }],
    staticClass: "justify-start",
    class: {
      pulse: _vm.isPlaying
    },
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "rounded": ""
    },
    on: {
      "click": _vm.toggle
    }
  }, 'v-btn', _vm.$attrs, false), _vm.$listeners), [_vm.isLoading || _vm.isPlaying ? _c('audio', {
    ref: "preview",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.src
    },
    on: {
      "ended": function ($event) {
        _vm.isPlaying = false;
      }
    }
  }) : _vm._e(), _vm._t("default"), _vm.isLoading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "24",
      "width": "2"
    }
  }) : _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.isPlaying ? _vm.mdiPause : _vm.mdiPlay)
    }
  }), _vm.name ? _c('span', {
    staticClass: "ml-2 pr-1 text-body-2",
    staticStyle: {
      "text-transform": "none",
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }